import CONST_IMAGES from 'constants/images';

export default {
  AIR_CONDITIONED: [
    { KEY: 1, VALUE: 'SIM' },
    { KEY: 0, VALUE: 'NÃO' },
  ],
  ACCESSIBLE: [
    { KEY: 1, VALUE: 'SIM' },
    { KEY: 0, VALUE: 'NÃO' },
  ],
  TICKETER: [
    { KEY: 1, VALUE: 'SIM' },
    { KEY: 0, VALUE: 'NÃO' },
  ],
  MODELS: [
    {
      KEY: 'MICRO',
      VALUE: 'MICRO-ÔNIBUS',
      WEIGHT: 5,
      SIZE: 7.4,
      IMAGES: [{ SRC: CONST_IMAGES.CAR_MODELS.STANDARD, LEGEND: '' }],
    },
    {
      KEY: 'MINI',
      VALUE: 'MINIÔNIBUS',
      WEIGHT: 8,
      SIZE: 0.6,
      IMAGES: [{ SRC: CONST_IMAGES.CAR_MODELS.STANDARD, LEGEND: '' }],
    },
    {
      KEY: 'MIDI',
      VALUE: 'MIDIÔNIBUS',
      WEIGHT: 10,
      SIZE: 11.5,
      IMAGES: [{ SRC: CONST_IMAGES.CAR_MODELS.STANDARD, LEGEND: '' }],
    },
    {
      KEY: 'BASIC',
      VALUE: 'ÔNIBUS BÁSICO',
      WEIGHT: 16,
      SIZE: 14,
      IMAGES: [{ SRC: CONST_IMAGES.CAR_MODELS.STANDARD, LEGEND: '' }],
    },
    {
      KEY: 'PADRON',
      VALUE: 'ÔNIBUS PADRON',
      WEIGHT: 16,
      SIZE: 14,
      IMAGES: [{ SRC: CONST_IMAGES.CAR_MODELS.STANDARD, LEGEND: '' }],
    },
    {
      KEY: 'ARTICULATE',
      VALUE: 'ÔNIBUS ARTICULADO',
      WEIGHT: 26,
      SIZE: 18.6,
      IMAGES: [{ SRC: CONST_IMAGES.CAR_MODELS.STANDARD, LEGEND: '' }],
    },
    {
      KEY: 'BIARTICULATE',
      VALUE: 'ÔNIBUS BIARTICULADO',
      WEIGHT: 36,
      SIZE: 30,
      IMAGES: [{ SRC: CONST_IMAGES.CAR_MODELS.STANDARD, LEGEND: '' }],
    },
  ],
  TABLE_HEADER: new Map([
    ['totalValue', 'Valor total'],
    ['valuePerKm', 'Valor por Quilômetro'],
    ['ipk', 'ipk'],
    ['ipke', 'ipke'],
    ['kvd', 'kvd'],
    ['pvd', 'pvd'],
  ]),
  VEHICLE_TYPE: {
    BUS: 0,
    TRAIN: 1,
    SHIP: 2,
  },
};
